import gql from 'graphql-tag'

const GET_PROJECT_STATUSES = gql`
  query projectStatuses($tenantId: Int!, $name: String, $offset: Int, $limit: Int) {
    projectStatuses(tenantId: $tenantId, name: $name, offset: $offset, limit: $limit) {
      total
      data {
        id
        status
      }
    }
  }
`

export { GET_PROJECT_STATUSES }
